import { getGoogleAdsParams } from "./tracking"
import { getPosthogDistinctId } from "./posthog"

function addPosthogDistinctId(urlObj) {
  const distinctId = getPosthogDistinctId()
  if (distinctId) {
    urlObj.searchParams.set("ph_distinct_id", distinctId)
  }
}

/**
 * Global link interceptor that automatically adds Google Ads tracking to app links
 */
export function initLinkInterceptor() {
  if (typeof window === "undefined") return

  // Get the app base URL from environment variable or default
  const appBaseUrl = process.env.GATSBY_APP_BASE_URL || "https://app.klang.ai"

  // Function to add tracking parameters to a URL
  function addTrackingToUrl(url) {
    try {
      const urlObj = new URL(url)
      const googleAdsParams = getGoogleAdsParams()

      // Add Google Ads tracking parameters
      Object.entries(googleAdsParams).forEach(([key, value]) => {
        if (value) {
          urlObj.searchParams.set(key, value)
        }
      })

      addPosthogDistinctId(urlObj)

      return urlObj.toString()
    } catch (error) {
      console.warn("Failed to add tracking to URL:", url, error)
      return url
    }
  }

  // Function to check if a URL should have tracking added
  function shouldAddTracking(url) {
    try {
      const urlObj = new URL(url)
      return urlObj.origin === appBaseUrl
    } catch {
      return false
    }
  }

  // Intercept clicks on links
  function handleLinkClick(event) {
    const link = event.target.closest("a")
    if (!link) return

    const href = link.getAttribute("href")
    if (!href) return

    // Check if this is an external link to our app
    if (shouldAddTracking(href)) {
      // Update the href attribute with tracking parameters
      const urlWithTracking = addTrackingToUrl(href)
      link.setAttribute("href", urlWithTracking)

      // Let the default behavior proceed (don't prevent default)
      // This allows existing onClick handlers to work normally
    }
  }

  // Add event listener for link clicks
  document.addEventListener("click", handleLinkClick, true)

  // Return cleanup function
  return () => {
    document.removeEventListener("click", handleLinkClick, true)
  }
}

/**
 * Manually add tracking to a URL (for programmatic navigation)
 */
export function addTrackingToUrl(url) {
  if (typeof window === "undefined") return url

  const appBaseUrl = process.env.GATSBY_APP_BASE_URL || "https://app.klang.ai"

  try {
    const urlObj = new URL(url)

    // Only add tracking if this is an app URL
    if (urlObj.origin !== appBaseUrl) {
      return url
    }

    const googleAdsParams = getGoogleAdsParams()

    // Add Google Ads tracking parameters
    Object.entries(googleAdsParams).forEach(([key, value]) => {
      if (value) {
        urlObj.searchParams.set(key, value)
      }
    })

    addPosthogDistinctId(urlObj)

    return urlObj.toString()
  } catch (error) {
    console.warn("Failed to add tracking to URL:", url, error)
    return url
  }
}
